<template>
<el-dialog :visible="visible" :title="'Registrar ' + title" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" @open="onOpened" @closed="onClosed">

    <el-form ref="ruleFormRef" :model="formSearch" :rules="rules" :label-position="'left'">
        <div class="row align-items-end">
            <div class="col-sm-4" v-if="record_type != 'DE'">
                <el-form-item label="Tipo de oficial" prop="record_type" class="m-0">
                    <el-select v-model="formSearch.record_type" class="w-100" placeholder="Tipo de oficial" size="small">
                        <el-option v-for="item in oficialType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div :class="(record_type == 'DE') ? 'col-sm-6' : 'col-sm-4'">
                <el-form-item label="Tipo de documento" prop="tpodoc" class="m-0">
                    <el-select v-model="formSearch.tpodoc" class="w-100" placeholder="Seleccione" size="small" @change="changeTpoDoc">
                        <el-option v-for="item in tpodocs" :key="item.idmstdetails" :label="item.name" :value="item.idmstdetails"></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div :class="(record_type == 'DE') ? 'col-sm-6' : 'col-sm-4'">
                <el-form-item label="Numero Documento" prop="docnumber" class="m-0">
                    <el-input ref="docnumber" v-model="formSearch.docnumber" class="w-100" size="small" :minlength="formSearch.tpodoc== 1 ? 8 : 3" :maxlength="formSearch.tpodoc== 1 ? 8 : 11" @keypress.enter.native="searchForm('ruleFormRef')" @keyup.native="search={}" show-word-limit></el-input>
                </el-form-item>
            </div>

        </div>

    </el-form>

    <div v-if="search.existe" class="alert alert-custom alert-light-danger fade show mt-4 mb-0" role="alert">
        <div class="alert-text" v-html="search.message"></div>
    </div>

    <div slot="footer" class="dialog-footer">
        <el-button size="small" class="" @click="onClose">Cancelar</el-button>

        <el-button v-if="search.existe == true && search.data !== null" type="primary" size="small" icon="el-icon-info" @click="viewInfo" class="mb-1">{{'Ver ' + title}}</el-button>
        <el-button v-else type="danger" size="small" icon="el-icon-search" :loading="loading_search" @click="searchForm('ruleFormRef')" class="mb-1">{{'Buscar'}}</el-button>

    </div>
</el-dialog>
</template>

<script>
import {
    mapGetters
} from "vuex";

import code from "@/core/config/error";

//services
import payrollService from "@/core/services/payroll.service"

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        title: {
            type: String,
            required: true,
            default: "",
        },
        record_type: {
            type: String,
            required: true,
            default: "",
        }
    },
    data: () => ({
        loading_search: false,
        search: {},
        formSearch: {
            tpodoc: '',
            docnumber: '',
            record_type: ''
        },
        rules: {
            tpodoc: [{
                required: true,
                message: 'Tipo de documento',
                trigger: ['blur', 'change']
            }],
            docnumber: [{
                required: true,
                message: 'Número documento',
                trigger: ['blur', 'change']
            }]
        }
    }),
    computed: {
        ...mapGetters(['tpodocs', 'oficialType'])
    },
    methods: {
        onClose() {
            this.$emit("update:visible", false);
        },
        onClosed() {
            this.$refs["ruleFormRef"].resetFields()
            this.loading_search = false
            this.search = {}
        },
        onOpened() {
            if (this.tpodocs.length > 0)
                this.formSearch.tpodoc = "1"
            this.formSearch.record_type = this.record_type

            /*if (this.activeItem == 'tab1')
                this.formSearch.record_type = 'DE'*/

        },
        viewInfo() {
            if (this.search.existe == true && this.search.data != null)
                this.$emit("onAddEdditDialog", this.search)
        },
        searchForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (!valid)
                    return false;

                this.search = {}
                this.loading_search = true
                await payrollService.searchPerson(this.formSearch).then((response) => {
                    this.search = response.data
                    this.$emit("resDialogSearch", this.search )
                }).catch((error) => {
                    code.Manager(error.response)
                }).finally(() => {
                    this.loading_search = false
                })
            });
        },
        changeTpoDoc() {
            this.formSearch.docnumber = '';
            this.$nextTick(function () {
                this.$refs.docnumber.focus()
            })
        }
    },
    created() {}

}
</script>
